export const USER_DETAILS = 'user-details';
export const CONFIRMATION_STATUS_OF_TAG_REMOVAL = 'remove';
export const OPTED_OUT_CONFIRMATION = 'optedOutConfirmation';
